/**
 * 查看班级
 * @author xyguo
 * @date 2020-12-21
 */
import React from 'react';
import { connect } from 'dva';
import { Descriptions } from 'antd';
import { framework_tool, component_tool, utils_tool } from '@/tool';
let { WizContainer, modelUtils, WizAvatarUpload, ossFileUtils } = framework_tool
let { WizModal, WizComponent, WizForm, WizCheckbox,WizCard } = component_tool;
let { $$, checkStrLength,Session } = utils_tool;


class LookClassInfo extends WizContainer {

  componentName = 'lookClassInfo';

  constructor(props) {
    super(props);
    const { history } = props
    let detailInfo = {};
    if (history.location && history.location.record) {
      detailInfo = history.location.record
      Session.set('classInfo', detailInfo)
    } else {
      detailInfo = Session.get('classInfo') || {}
    }
    this.state = {
    }
    this.detailInfo = detailInfo
  }


  render() {
    let record =  this.detailInfo;
    let useTypeStr = '';
    switch (record.useType) {
      case 0:
        useTypeStr = '新产品培训'
        break;
      case 1:
        useTypeStr = '实操培训'
        break;
      case 2:
        useTypeStr = '岗位培训'
        break;
      case 3:
        useTypeStr = '区域会议'
        break;
      case 4:
        useTypeStr = '岗位认证'
        break;
      case 5:
        useTypeStr = '其他'
        break;
    }

    return (

      // <WizForm {...formProps} />
      <React.Fragment>
        {/* <WizSpin tip={'加载中'} spinning={this.props.interactLiveLoading}> */}
        <WizCard>
          <Descriptions column={1} bordered={true}>
            <Descriptions.Item label='班级名称'>{record.name}</Descriptions.Item>
            <Descriptions.Item label='所属主题'>{record.programName}</Descriptions.Item>
            <Descriptions.Item label='班级类型'>{record.typeStr}</Descriptions.Item>
            <Descriptions.Item label='班级时间'>{record.startDate + "~" + record.endDate}</Descriptions.Item>
            {record.type === 0 ? <Descriptions.Item label='教室'>{record.trainSiteName}</Descriptions.Item> : null}
            {record.type === 0 ? <Descriptions.Item label='培训中心'>{record.address}</Descriptions.Item> : null}
            {record.type === 0 ? <Descriptions.Item label='使用类型'>{record.useTypeStr}</Descriptions.Item> : null}
            <Descriptions.Item label='状态'>{record.statusStr}</Descriptions.Item>
            <Descriptions.Item label='限制人数'>{record.limitNum}</Descriptions.Item>
            <Descriptions.Item label='讲师'>{record.lectureName}</Descriptions.Item>
            <Descriptions.Item label='安全协议'>{record.secProtocolStr}</Descriptions.Item>
            <Descriptions.Item label='保密协议'>{record.conAgreementStr}</Descriptions.Item>
            <Descriptions.Item label='介绍'>{record.intro}</Descriptions.Item>
          </Descriptions>
        </WizCard>
        {/* </WizSpin> */}
      </React.Fragment>

    );
  }
}

const mapStateToProps = (state, ownProps) => {
  return {
    
  }
};

export default connect(mapStateToProps)(LookClassInfo)

